import React from 'react';
import { Route } from 'react-router-dom';
import { parseRouteParams } from './AppRoot';
import NoSitecoreRouteHandler from './NoSitecoreRouteHandler';
import { NoSitecoreRouteProps } from './types';

const NoSitecoreRoute = ({
  path,
  Component,
  ssrState,
  currentPath,
  exact = false
}: NoSitecoreRouteProps) => (
  <Route
    path={path}
    exact={exact}
    render={(routeProps) => (
      <NoSitecoreRouteHandler
        {...parseRouteParams(currentPath as string | undefined)}
        routeProps={routeProps as any}
        isSSR={!!ssrState}
      >
        <Component {...routeProps} />
      </NoSitecoreRouteHandler>
    )}
  />
);

export default NoSitecoreRoute;
